import { render } from "./LinkProductsToCustomerDepotDiscountGroupModal.html?vue&type=template&id=72b2abbb&scoped=true"
import script from "./LinkProductsToCustomerDepotDiscountGroupModal.js?vue&type=script&lang=js"
export * from "./LinkProductsToCustomerDepotDiscountGroupModal.js?vue&type=script&lang=js"

import "./LinkProductsToCustomerDepotDiscountGroupModal.css?vue&type=style&index=0&id=72b2abbb&scoped=true&lang=css"

import exportComponent from "/Users/blakegilbert/Documents/Projects/ShipTech/st-web-petro-network-admin-portal/src/ST.PetroNetworkAdmin.Web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-72b2abbb"]])

export default __exports__